import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { queryOrderDetail } from "../endpoints/order";
import { useBackendCurrency, useBackendLang } from "../lang-context";
import type { OrderDetail } from "../types/order";

export function useOrderDetail(authToken: string | null, orderNo: string) {
  const lang = useBackendLang();
  const currency = useBackendCurrency();
  return useQuery<OrderDetail>({
    queryKey: ["orders", "detail", orderNo, lang, currency],
    enabled: !!authToken && !!orderNo,
    queryFn: () => {
      if (!authToken) throw new Error("NO_TOKEN");
      return queryOrderDetail({ baseUrl: API_BASE_URL }, authToken, orderNo, { lang, currency });
    },
    staleTime: 30_000,
  });
}
